export const todayISO = () => new Date().toISOString().split("T")[0];
